// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"index_breadcrumbs_1owaC","current":"index_current_1rCqp","arrow":"index_arrow_1h4nZ"};